<template>
  <b-alert
    :show="isShow"
    :variant="alertVariant"
    class="p-2"
  >
    <div v-html="alertText" />
    <b-button
      :variant="buttonVariant"
      class="mt-2 mr-1"
      @click="$router.push({name: routeName})"
    >
      {{ buttonText }}
    </b-button>
  </b-alert>
</template>
<script>
import RedirectAlert from '@/views/logics/components/RedirectAlert'

export default {
  mixins: [RedirectAlert],
}
</script>

  <style scoped>
  .logo {
    width: 150px;
  }
  </style>
